import { useState } from 'react';
import { readabilityService } from '../../../../services/readability-service';

export const useTextLookup = () => {
  const [inputText, setInputText] = useState('');
  const [lookupResult, setLookupResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleInputChange = (e) => {
    setLookupResult(null);
    setError(null);
    setInputText(e.target.value);
  };

  const clearInput = () => {
    setInputText('');
    setLookupResult(null);
    setError(null);
  };

  const lookupText = async () => {
    if (!inputText.trim()) {
      setError('Please enter some text to lookup');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await readabilityService.lookupText({ text: inputText });
      setLookupResult(response);
    } catch (err) {
      console.error('Lookup error:', err);
      setError('Error looking up text. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setSnackbarMessage('Copied to clipboard');
    } catch (err) {
      console.error('Could not copy text: ', err);
      setSnackbarMessage('Failed to copy to clipboard');
    }
  };

  const clearSnackbarMessage = () => setSnackbarMessage('');

  return {
    // State
    inputText,
    lookupResult,
    loading,
    error,
    snackbarMessage,
    
    // Actions
    handleInputChange,
    clearInput,
    lookupText,
    copyToClipboard,
    clearSnackbarMessage,
    
    // Computed values
    canLookup: !loading && inputText.trim(),
    hasResults: !!lookupResult
  };
};